import { createFileRoute, Navigate } from '@tanstack/react-router'
import { payablesSummarySearchSchema } from '../../../schemas'

export const Route = createFileRoute('/_layout/billing-and-payments/')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <Navigate
            to="/billing-and-payments/payables-summary"
            search={payablesSummarySearchSchema.parse({})}
        />
    )
}
